<template>
  <div class="user-center__maintain-demand-container user-center__common-child-container">
    <SubPageHeader>
      <template #title>
        <router-link tag="div" :to="nav.url" active-class="active" class="title__front-item"
          v-for="(nav, index) in breadcrumbs" :key="index">{{ nav.name }}</router-link>
      </template>
      <template #hint>
        <el-button class="yellow btn" @click="toImportRequirement">发布项目</el-button>
      </template>
    </SubPageHeader>
    <div class="demand__main-body">
      <div class="maintain__rule-board">
        <div class="inner">
          <p class="title">使用说明：</p>
          <p>
            1、本列表内的项目由平台依据商家供应能力匹配，每次同品类需求仅推送一家，请重视本页面的需求推送。
          </p>
          <p>
            2、请先[查看需求]，确认是能够争取的项目，如果能够跟进就请点选[确认跟进需求]，确认跟进需求会扣除{{
              followupConfigs ? followupConfigs.join : 0
            }}积分，如果半途退出不再返还。
          </p>
          <p>
            3、<b>跟进奖励积分</b>，每次提交需求跟进记录就会奖励{{
              followupConfigs ? followupConfigs.score : 0
            }}积分（上限{{
  followupConfigs ? followupConfigs.score * followupConfigs.limit : 0
}}积分）。
          </p>
        </div>
      </div>
      <div class="demand__list-container" v-if="records.length > 0" v-loading="recordLoading">
        <ul class="demand__list-wrapper">
          <li class="demand__item" v-for="(record, rindex) in records" :key="record.id"
            :class="itemClass(record.attendStatus)">
            <div class="inner">
              <div class="text-block">
                <div class="name">
                  <p>
                    <span>{{ record.demand.parentmold ? record.demand.parentmold.name : "" }}_</span><span>{{
                      record.demand.name }}</span>
                  </p>
                </div>
                <div class="demand-data">
                  <div class="followup-record" v-if="record.attendStatus !== null">
                    <div class="record-item" :class="{
                      '-brand': isBrand,
                    }">
                      <p>
                        跟进人：{{
                          isMerchant
                          ? $parent.user
                            ? "本账号跟进"
                            : ""
                          : record.followupInfo
                            ? record.followupInfo.contact
                            : "本账号跟进"
                        }}
                      </p>
                      <el-button v-if="distributeAuth(record.attendStatus)" type="button"
                        @click="distribute(record.demand_id)">
                        [{{
                          Number(record.followupInfo.id) === Number(user.info.store_id)
                          ? "派发需求"
                          : "修改跟进人"
                        }}]
                      </el-button>
                    </div>
                    <div class="record-item">
                      <p>
                        最新跟进状态：<span>{{
                          record.records.length > 0
                          ? record.records["0"]["process"]
                          : "还未填写跟进记录"
                        }}</span>
                        <span v-if="record.records.length > 0">（更新于：{{ record.records["0"]["updated_at"] }}）</span>
                      </p>
                    </div>
                  </div>
                  <div class="data-inner">
                    <div class="ctime">{{ record.created_at.split(" ")["0"] }}</div>
                    <div class="created">
                      <p>跟进次数：</p>
                      <p>{{ record.records.length }}</p>
                    </div>
                  </div>
                </div>
                <div class="user-action">
                  <template v-if="record.attendStatus === null">
                    <el-button class="view" @click="detailDemand(record.demand_id)">查看需求</el-button>
                    <el-button class="confirm" @click="($event) => demandConfirm($event, record.demand_id, getDemand)"
                      :loading="indexLoading == (rindex + 1) * 4 - 3"
                      :data-index="(rindex + 1) * 4 - 3">确认跟进需求</el-button>
                  </template>
                  <template v-else-if="record.attendStatus == 0">
                    <el-button class="fill" @click="detailDemand(record.demand_id, record.followID)">跟进项目</el-button>
                    <el-button class="cancel"
                      @click.passive="($event) => cancelDemand($event, record.followID, getDemand)" v-if="isBrand"
                      ref="cancelBt" :loading="indexLoading == (rindex + 1) * 4 - 2"
                      :data-index="(rindex + 1) * 4 - 2">取消跟进</el-button>
                    <el-button class="cancel" ref="suspendBt" @click="($event) =>
                      suspendDemand($event, record.demand_id, record.followID, getDemand)
                      " :loading="indexLoading == (rindex + 1) * 4 - 1"
                      :data-index="(rindex + 1) * 4 - 1">终止跟进</el-button>
                  </template>
                  <template v-else-if="record.attendStatus == 11">
                    <el-button class="view" @click="detailDemand(record.demand_id, record.followID)">
                      查看历史
                    </el-button>
                  </template>
                </div>
              </div>
              <div class="cover-block">
                <img :src="record.demand.titleimg
                  ? record.demand.titleimg.url
                  : 'http://api.material-online.cn/public/uploads/images/20220226/ea0c2239901741170988bf33d50880b0_thumb.jpg'
                  " alt="" />
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <empty hint="暂无新需求" v-if="records.length == 0 && paginationConfig && paginationConfig.total == 0"></empty>
    <pagination class="component-pagination" v-if="paginationConfig && paginationConfig.total > 0"
      :config="paginationConfig"></pagination>
    <!-- 弹出经销商选出 -->
    <distribute-merchant :demandID="distributionDemandID" :show.sync="distributeShow" :callback="getDemand"
      @onClose="onDistributeClose"></distribute-merchant>
  </div>
</template>
<script>
import SubPageHeader from "../_pageHeader.vue";
import Pagination from "@/components/pagination.vue";
import Empty from "@/pages/common/empty.vue";

import { FOLLOW_STATUS_NORMAL, FOLLOW_STATUS_SUSPEND } from "@/assets/utils/dict";

import { readFollowup, myMaintainDemands } from "@/api/user";

import { followup } from "@/mixins/followup";

import distributeMerchant from "./_select-merchant.vue";

import { mapState } from "vuex";

export default {
  name: "followupList",
  components: {
    SubPageHeader,
    Pagination,
    Empty,
    distributeMerchant,
  },
  mixins: [followup],
  data() {
    return {
      breadcrumbs: [
        {
          name: "项目跟进",
          url: "/my/maintains",
        },
      ],
      records: [],
      paginationConfig: null,
      recordLoading: false,
      cancelLoading: false,
      distributionDemandID: 0,
      distributeShow: false,
      followOperator: [FOLLOW_STATUS_NORMAL, FOLLOW_STATUS_SUSPEND],
    };
  },
  computed: {
    ...mapState(["followupConfigs", "user"]),
    page() {
      return this.$route.query.page || 1;
    },
    userType() {
      return this.$parent.user && this.$parent.user.type === undefined ? 0 : this.$parent.user.type;
    },
    isMerchant() {
      return this.userType == 2;
    },
    isBrand() {
      return this.userType == 1;
    },
  },
  watch: {
    page(val) {
      this.getDemand();
    },
  },
  created() {
    this.getDemand();
  },
  mounted() {
    this.readFollowup();
  },
  methods: {
    itemClass(attendStatus) {
      return {
        "--suspend": attendStatus == FOLLOW_STATUS_SUSPEND,
      };
    },
    readFollowup() {
      this.$parent.$emit("followupread");

      readFollowup().then((res) => {
        console.log(res);
      });
    },
    getDemand() {
      const that = this;
      that.recordLoading = true;
      myMaintainDemands({
        page: that.page,
      }).then((res) => {
        const { list, pagination } = res.data;
        this.records = list;
        this.paginationConfig = pagination;
        that.recordLoading = false;
      });
    },
    detailDemand(demandID, followID = 0) {
      let url = `/my/maintain/${demandID}`;
      if (followID > 0) {
        url = `${url}?followID=${followID}`;
      }
      this.$router.push({
        path: url,
      });
    },
    distribute(demandID) {
      this.distributionDemandID = demandID;
      this.distributeShow = true;
    },
    onDistributeClose() {
      this.distributionDemandID = 0;
      this.distributeShow = false;
    },
    distributeAuth(attendStatus) {
      return this.isBrand && attendStatus == FOLLOW_STATUS_NORMAL;
    },
    toImportRequirement() {
      this.$router.push({
        path: '/my/requirement/create',
        query: {
          type: 'important'
        }
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.yellow.btn {
  border: 0;
  background-color: #fabe00;
  color: #fff;
  cursor: pointer;
}
</style>